import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getHiLoGamePendingBetsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pending-bets/hiLo-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getCoinHeistGamePendingBetsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pending-bets/coin-heist-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getMineGamePendingBetsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pending-bets/mine-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const cancelBetService = (betData) => {
  return axiosInstance(METHOD_TYPES.post, '/pending-bets/cancel', betData, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Bet cancelled successfully'
  })
}
